import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/VideoSection.css';

function VideoSectionENG() {
  const [isPlaying, setIsPlaying] = useState(false);

  const PLAYLIST_ID = 'PLT0_3jl_6IHe_vty4IxtWun2g_s0JkzVw';

  const handlePlayClick = () => {
    setIsPlaying(true);
    document.body.style.overflow = 'hidden';
  };

  const closePlayer = () => {
    setIsPlaying(false);
    document.body.style.overflow = 'unset';
  };

  return (
    <section className="video-section" style={{ textAlign: 'left', direction:'ltr' }}>
      <div className="container">
        <h2 className="video-title">Testimonies</h2>

        <div className="playlist-container">
          <div className="playlist-preview">
            <div className="playlist-thumbnail" onClick={handlePlayClick}>
              <img
                src="/images/tumb.jpg"
                alt="Playlist Preview"
              />
              <div className="play-button-large">
                <div className="play-icon"></div>
              </div>
              <div className="playlist-overlay">
                <div className="playlist-info">
                  <span className="playlist-badge">PLAYLIST</span>
                  <h3 className="playlist-title">Testimonies of victims of digital violence</h3>
                  <p className="playlist-description">
                    A collection of real Testimonies from individuals who experienced digital violence and how they overcame it.
                  </p>
                </div>
              </div>
            </div>

            <div className="playlist-videos-list">
              <div className="playlist-header">
                <h4>Playlist content</h4>
              </div>
              <div className="video-items">

                <div className="video-item" onClick={handlePlayClick}>
                  <div className="item-thumbnail">
                    <img src="/images/tumb.jpg" alt="Video 1" />
                    <div className="item-play-icon"></div>
                  </div>
                  <div className="item-info">
                    <h5>Testimony from a victim of digital violence</h5>
                    <p>A woman's experience with online blackmail and how she overcame it.</p>
                  </div>
                </div>

                <div className="video-item more-videos" onClick={handlePlayClick}>
                  <div className="more-indicator">
                    <span>+12</span>
                    <p>More Testimonies</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className="video-cta-container">

            <button className="cta-button">More Testimonies</button>

        </div>
      </div>

      {isPlaying && (
        <div className="video-modal-overlay" onClick={closePlayer}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={closePlayer} aria-label="Close">
              ×
            </button>
            <div className="video-player-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/videoseries?list=${PLAYLIST_ID}&autoplay=1&rel=0`}
                title="YouTube Playlist"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default VideoSectionENG;
